export const SIZE_CATEGORY = {
  SM_TO_MD: 'small-to-medium',
  MD_TO_LG: 'medium-to-large'
}
